<template>
  <div class="page-wrapper">
    <el-row class="common-row">
      <el-col :span="19" :xs="{ span: 24 }" class="common-col-left">
        <router-view />
      </el-col>
      <el-col :span="5" :xs="{ span: 24 }" class="common-col-right">
        <div class="right-content-wrapper"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ScheduleView',
  data() {
    return {}
  },
  methods: {},
}
</script>
<style scoped lang="less">
.right-content-wrapper {
  padding: 20px;
  .text-select-label {
    font-size: 20px;
  }
  .text-select-value {
    font-size: 20px;
    margin: 8px 0 10px;
  }
}
</style>
